// ServConsultData.js

// export const ServConsultTopImg = [
//   {
//     id: 1,
//     image: require('../images/ServiceImg/ConsultTop/AdvancedSurfaceTreatmentB.png'),
//     alt: 'images/ServiceImg/ConsultTop/AdvancedSurfaceTreatmentB.png',
//   },
//   {
//     id: 2,
//     image: require('../images/ServiceImg/ConsultTop/AdvancedSurfaceTreatmentA.png'),
//     alt: 'images/ServiceImg/ConsultTop/AdvancedSurfaceTreatmentA.png',
//   },
//   {
//     id: 3,
//     image: require('../images/ServiceImg/ConsultTop/ConsultFromStartA.png'),
//     alt: 'images/ServiceImg/ConsultTop/ConsultFromStartA.png',
//   },
//   {
//     id: 4,
//     image: require('../images/ServiceImg/ConsultTop/ConsultFromStartC.png'),
//     alt: 'images/ServiceImg/ConsultTop/ConsultFromStartC.png',
//   },
//   {
//     id: 5,
//     image: require('../images/ServiceImg/ConsultTop/CoreAdvantage.png'),
//     alt: 'images/ServiceImg/ConsultTop/CoreAdvantage.png',
//   },
//   {
//     id: 6,
//     image: require('../images/ServiceImg/ConsultTop/CoreStrength.png'),
//     alt: 'images/ServiceImg/ConsultTop/CoreStrength.png',
//   },
//   {
//     id: 7,
//     image: require('../images/ServiceImg/ConsultTop/CoreTechStandard.png'),
//     alt: 'images/ServiceImg/ConsultTop/CoreTechStandard.png',
//   },
//   {
//     id: 8,
//     image: require('../images/ServiceImg/ConsultTop/EolManagement.png'),
//     alt: 'images/ServiceImg/ConsultTop/EolManagement.png',
//   },
//   {
//     id: 9,
//     image: require('../images/ServiceImg/ConsultTop/HighIntegratedCoreValue.png'),
//     alt: 'images/ServiceImg/ConsultTop/HighIntegratedCoreValue.png',
//   },
//   {
//     id: 10,
//     image: require('../images/ServiceImg/ConsultTop/OdmOemWorkflow.png'),
//     alt: 'images/ServiceImg/ConsultTop/OdmOemWorkflow.png',
//   },
//   {
//     id: 11,
//     image: require('../images/ServiceImg/ConsultTop/OptimizeOdmOemProcess.png'),
//     alt: 'images/ServiceImg/ConsultTop/OptimizeOdmOemProcess.png',
//   },
//   {
//     id: 12,
//     image: require('../images/ServiceImg/ConsultTop/WorldMostComprehenCTP.png'),
//     alt: 'images/ServiceImg/ConsultTop/WorldMostComprehenCTP.png',
//     // link: 'https://touchinternational.com/applications/#top',
//   },
// ]

// export const ServConsultTopTxt = [
//   {
//     id: 0,
//     // image: require('../images/ServiceImg/Consult/Odm&OemWorkflow.png'),
//     // alt: 'images/ServiceImg/Consult/Odm&OemWorkflow.png',
//     name: 'Building The Best Touch Panel',
//     title: '打造最佳觸控面板',
//     subtitle: '適用於高可靠性應用的觸控面板解決方案',
//     text: '全场景触控解决方案：赋能未来产业升级\n' +
//       '在科技高速发展的时代，投射式电容触摸屏广泛应用于消费电子产品、汽车电子、零售业、医疗设备、工业控制，军事领域，机器人，\n' +
//       '通讯设备，安防，智能家居，能源等领域，在多个场景为人类提供优秀的体验以及高效的服务作为全球领先的触摸屏面板制造商，\n' +
//       'HLZ深耕人机交互技术领域，以创新驱动为核心，为航空航天、工业控制、智能家居、交通运输、POS零售、医疗及教育等行业提供定制化触控解决方案，满足严苛环境下的高性能需求。\n' +
//       ' ',
//     // nameEng: 'Building Better Touch Panel',
//     // titleEng: '打造更佳觸控面板',
//     // subtitleEng: 'Touchscreen Solutions for High-Reliability Applications',
//     // textEng:
//     //      'Engineering advanced touch-enabled products for peak performance in rugged and professional environments while meeting or exceeding regulatory compliances and quality assurance.' +
//     //      'HLZ Technology’s expert engineering, design, and manufacturing teams in the U.S., China, and India are well-equipped to deliver on the company’s capabilities of high-mix, low-volume production with rapid prototyping.' +
//     //      'Additionally, our facilities boast Class 10,000 cleanrooms, ensuring products meet the uncompromising quality demands required in high-reliability applications.' +
//     //      'Our commitment to building industry-reliable products complies with stringent ITAR, AS9100, ISO9001, and ISO13485 standards.',
//     // describe: 'ServConsultTop',
//     link: 'https://touchinternational.com/applications/#top',
//     time: '2025/2/13',
//   },
// ]

export const ServConsultImg = [
  {
    id: 1,
    image: require('../images/ServiceImg/Consult/AdvancedSurfaceTreatmentA.png'),
    alt: 'images/ServiceImg/Consult/AdvancedSurfaceTreatmentA.png',
  },
  {
    id: 2,
    image: require('../images/ServiceImg/Consult/AdvancedSurfaceTreatmentB.png'),
    alt: 'images/ServiceImg/Consult/AdvancedSurfaceTreatmentB.png',
  },
  {
    id: 3,
    image: require('../images/ServiceImg/Consult/AdvancedSurfaceTreatmentC.png'),
    alt: 'images/ServiceImg/Consult/AdvancedSurfaceTreatmentC.png',
  },
  {
    id: 4,
    image: require('../images/ServiceImg/Consult/ConsultFromStartA.png'),
    alt: 'images/ServiceImg/Consult/ConsultFromStartA.png',
  },
  {
    id: 5,
    image: require('../images/ServiceImg/Consult/ConsultFromStartB.png'),
    alt: 'images/ServiceImg/Consult/ConsultFromStartB.png',
  },
  {
    id: 6,
    image: require('../images/ServiceImg/Consult/ConsultFromStartC.png'),
    alt: 'images/ServiceImg/Consult/ConsultFromStartC.png',
  },
  {
    id: 7,
    image: require('../images/ServiceImg/Consult/CoreAdvantage.png'),
    alt: 'images/ServiceImg/Consult/CoreAdvantage.png',
  },
  {
    id: 8,
    image: require('../images/ServiceImg/Consult/CoreStrength.png'),
    alt: 'images/ServiceImg/Consult/CoreStrength.png',
  },
  {
    id: 9,
    image: require('../images/ServiceImg/Consult/CoreTechStandard.png'),
    alt: 'images/ServiceImg/Consult/CoreTechStandard.png',
  },
  {
    id: 10,
    image: require('../images/ServiceImg/Consult/EolManagement.png'),
    alt: 'images/ServiceImg/Consult/EolManagement.png',
  },
  {
    id: 11,
    image: require('../images/ServiceImg/Consult/HighIntegratedCoreValue.png'),
    alt: 'images/ServiceImg/Consult/HighIntegratedCoreValue.png',
  },
  {
    id: 12,
    image: require('../images/ServiceImg/Consult/OdmOemWorkflow.png'),
    alt: 'images/ServiceImg/Consult/Odm&OemWorkflow.png',
  },
  {
    id: 13,
    image: require('../images/ServiceImg/Consult/OptimizeOdmOemProcess.png'),
    alt: 'images/ServiceImg/Consult/OptimizeOdm&OemProcess.png',
  },
  {
    id: 14,
    image: require('../images/ServiceImg/Consult/OptimizeOdmOemProcess.png'),
    alt: 'images/ServiceImg/Consult/OptimizeOdm&OemProcess.png',
    // link: 'https://touchinternational.com/applications/#top',
  },
]

export const ServConsultTxt = [
  {
    id: 1,
    // image: require('../images/ServiceImg/Consult/AdvancedSurfaceTreatmentB.png'),
    // alt: 'images/ServiceImg/Consult/AdvancedSurfaceTreatmentB.png',
    name: '1.	PCap Touch Panel Design(投射电容式触摸屏设计)',
    title: '核心优势：全球最全品类CTP产品矩阵',
    subtitle: '全球最全品类CTP产品矩阵',
    text:
      '我们提供覆盖全场景的电容触摸屏产品链，满足消费电子到工业硬件的严苛需求\n' +
      '  投射式功能玻璃：\n' +
      '     超薄一体式，结构(0.4-15mm)，支持异形设计，适用于全场景触摸应用\n' +
      '  GG结构CTP：\n' +
      '     钢化玻璃+玻璃功能片组合，透光率＞85%，性价比高广泛用于医疗、教育，\n' +
      '     军工及工业控制设备\n' +
      '  GFF结构CTP：\n' +
      '     钢化玻璃+双膜层柔性结构功能片，抗冲击性强，广泛应用于交通运输、\n' +
      '     智能家居及POS终端\n' +
      '  触控显示全贴合：\n' +
      '     真空层压技术消除空气折射，屏幕对比度提升40%，增加清晰度，\n' +
      '     视觉效果好，专为医疗显示器、AR设备及高精度仪器屏打造\n' +
      '  智造实力：\n' +
      '     支持4.3-65英寸定制化生，月产能突破100K\n' +
      ' ',
  },
  {
    id: 2,
    // image: require('../images/ServiceImg/Consult/AdvancedSurfaceTreatmentB.png'),
    // alt: 'images/ServiceImg/Consult/AdvancedSurfaceTreatmentB.png',
    name: '2.	尖端表面处理技术',
    title: '尖端表面处理技术',
    subtitle: '尖端表面处理技术',
    text:
      '通过纳米级复合工艺实现八大功能特性，重塑触控体验边界\n' +
      '  AG防眩：\n' +
      '     微米蚀刻雾化技术(5%-30%雾度可调)，提升强光环境下300%可视性，\n' +
      '     户外设备首选方案\n' +
      '  AR减反射：\n' +
      '     多层光学镀膜将反射率压缩至＜0.5%，显示色彩还原度达98%(NTSC标准)\n' +
      '  AF抗污：\n' +
      '     纳米疏油涂层实现水接触角＞115°，减少90%指纹残留并提升触控顺滑度\n' +
      '  抗UV：\n' +
      '     紫外线吸收层阻隔率＞99.9%，有效防止户外设备黄变，延长3倍使用寿命\n' +
      '  抗IR：\n' +
      '     红外屏蔽涂层(800-1500nm波长阻隔)，保障金融ATM机防偷拍及\n' +
      '     军工设备防红外侦测\n' +
      '  电磁屏蔽：\n' +
      '     纳米银涂层屏蔽效能>40dB(18GHz频段)，多点接地设计使静电泄放<0.1秒，\n' +
      '     工业场景误触率降低90%\n' +
      '  除霜加热：\n' +
      '     ITO透明导电膜升温速率5℃/秒，-20℃环境除霜时间<30秒，\n' +
      '     支持分区控温算法，能耗降低30%\n' +
      '  抗菌层(可选)：\n' +
      '     银离子嵌入技术使医疗/教育设备细菌灭活率＞99%\n' +
      '  技术突破：\n' +
      '     独家AG+AR+AF三重复合涂层，透光率损失降至5%以下(行业平均12%)\n' +
      ' ',
  },
  {
    id: 3,
    // image: require('../images/ServiceImg/Consult/AdvancedSurfaceTreatmentC.png'),
    // alt: 'images/ServiceImg/Consult/AdvancedSurfaceTreatmentC.png',
    name: '3.	服务赋能体系',
    title: '加强服务体系',
    subtitle: '加强服务体系',
    text:
      '全周期技术陪跑—从概念到量产的深度协作：\n' +
      '  免费咨询诊断：\n' +
      '     72小时出具触控方案选型报告\n' +
      '  原型快速打样：\n' +
      '     10-14天交付支持10+种表面工艺组合的CTP触摸屏样片\n' +
      '  量产护航计划：\n' +
      '     良率管控系统实现直通率＞97%，全链路成本优化\n' +
      '  失效分析实验室：\n' +
      '     提供ESD防护、盐雾腐蚀测试及-40℃~85℃高低温可靠性验证\n' +
      ' ',
  },
  {
    id: 4,
    // image: require('../images/ServiceImg/Consult/ConsultFromStartA.png'),
    // alt: 'images/ServiceImg/Consult/ConsultFromStartA.png',
    name: '4.	行业解决方案标杆案例',
    title: '行业解决方案标杆案例',
    subtitle: '行业解决方案标杆案例',
    text:
      '长期建立各行业解决方案实例\n' +
      '  车载触控：\n' +
      '     AG+抗UV全景触摸屏(丰田汽车二级供应商)\n' +
      '  医疗显示：\n' +
      '     抗菌AF+高透AR手术监护屏(通过FDA Class III认证)支持湿手套操作，\n' +
      '     细菌灭活率>99%\n' +
      '  军工设备：\n' +
      '     电磁屏蔽+抗IR触控模组，通过GJB150电磁脉冲防护标准，\n' +
      '     耐盐雾腐蚀>500小时\n' +
      '  工业物联网：\n' +
      '     GFF结构抗IR触控模组(三一重工智慧工厂项目)\n' +
      '  新零售终端：\n' +
      '     全贴合防爆AG玻璃(万达广场2000台自助终端)\n' +
      '  户外工业屏：\n' +
      '     全贴合防爆AG玻璃+加热层，抗1.5米跌落冲击，强光可视性提升300%\n' +
      ' ',
  },
  {
    id: 5,
    // image: require('../images/ServiceImg/Consult/ConsultFromStartB.png'),
    // alt: 'images/ServiceImg/Consult/ConsultFromStartB.png',
    name: '5.	相容性(兼容性)',
    title: '相容性(兼容性)',
    subtitle: '相容性(兼容性)',
    text:
      '相容性(兼容性)技术要求\n' +
      '  硬件接口兼容性\n' +
      '     ＊控制器匹配：\n' +
      '         投射电容需搭配专用控制器(如禾瑞亚系列)，不同尺寸对应不同控制器型号\n' +
      '         (如禾瑞亚EXC81W32支持4-10"屏，禾瑞亚EXC81w46支持12.1-15.6"屏)，\n' +
      '         否则易导致触控失灵或精度下降\n' +
      '     ＊信号干扰抑制：工业环境中电磁干扰(EMI)需通过多点接地设计\n' +
      '         (静电泄放<0.1秒)和屏蔽层结构(如GFFF结构的EMI隔离层)解决，\n' +
      '         屏蔽效能需达30-65dB(18GHz频段)\n' +
      '  软件协议兼容性\n' +
      '     ＊驱动与操作系统：支持Windows/Linux/Android系统，并提供完整驱动套件\n' +
      '         (如禾瑞亚控制器驱动)，确保触控指令精准传输\n' +
      '     ＊手势算法：多点触控需兼容缩放、旋转等复杂手势协议，部分军工场景需\n' +
      '         定制手套/水下操作模式\n' +
      '  环境适应性\n' +
      '     ＊温度范围：工业级标准为-30~+70℃，军工级扩展至-40~85℃\n' +
      '         (如车载屏需支持-40℃快速除霜)\n' +
      '     ＊防护等级：IP65及以上(防尘防水)，医疗设备需抗菌涂层\n' +
      '         (银离子灭菌率>99%)\n' +
      '     ＊抗紫外线/化学腐蚀：户外设备需抗UV层(阻隔400nm以下紫外线，\n' +
      '         通过ASTM G154加速老化测试1000小时)\n' +
      ' ',
  },
  {
    id: 6,
    // image: require('../images/ServiceImg/Consult/ConsultFromStartC.png'),
    // alt: 'images/ServiceImg/Consult/ConsultFromStartC.png',
    name: '6.	核心技术标准体系',
    title: '核心技术标准体系',
    subtitle: '核心技术标准体系',
    text:
      '技术标准体系\n' +
      '  电气性能标准\n' +
      '     ＊触控点数：工业级≥10点，军工/医疗级≥20点(大屏指挥系统)\n' +
      '     ＊响应延迟：工业级<20ms，军工级<10ms(ISO 9241-300标准)\n' +
      '     ＊EMC抗扰度：通过IEC 61000-4-3/4-6认证，辐射耐受性达10V/m(军工级)\n' +
      '     ＊绝缘电阻：高温高湿(100℃/85%RH)环境下需稳定在5.0E+15Ω(医疗/车载)\n' +
      '  光学性能标准\n' +
      '     ＊透光率：常规屏≥89%(GG结构)或≥87%(GFF结构)，\n' +
      '         高端医疗/车载屏需≥95%(AR镀膜反射率<0.5%)\n' +
      '     ＊雾度：AG处理时可控在5%-30%，非AG屏需<3%\n' +
      '     ＊耐黄变：OC光阻剂在230℃下透光率>98%，高温高湿环境透光损失<2%\n' +
      '  结构与环境可靠性标准\n' +
      '     ＊机械强度：表面玻璃硬度≥7H(AG/AR类型)，抗冲击>10J(GB 15763.2标准)\n' +
      '     ＊寿命周期：>10万次冷热循环(车载屏)、>1亿次触控(工业控制台)\n' +
      '     ＊化学耐受性：耐酒精、消毒液擦拭(医疗屏通过FDA Class III认证)\n' +
      '  材料与工艺标准\n' +
      '     ＊电极设计：采用并联电极串结构(X/Y轴感应层双电极串并联)，\n' +
      '         降低内阻值30%，提升大尺寸屏灵敏度\n' +
      '     ＊贴合工艺：真空全贴合消除空气层，对比度提升40%，避免户外灰雾现象\n' +
      '     ＊OCA光学胶：需含耐热树脂(甲基丙烯酸共聚物)及交联剂(季戊四醇丙烯酸酯)，\n' +
      '         确保显影精度(Profile坡度角<30°)\n' +
      ' ',
    describe: 'ServConsultData',
    time: '2025/2/13',
  },
  {
    id: 7,
    // image: require('../images/ServiceImg/Consult/CoreAdvantage.png'),
    // alt: 'images/ServiceImg/Consult/CoreAdvantage.png',
    name: '7.	EOL管理的核心目标与重要性以及核心任务与技术策略',
    title: 'EOL管理的核心目标与核心任务与技术策略',
    // title: 'EOL管理的核心目标与重要性以及核心任务与技术策略',
    subtitle: 'EOL管理的核心目标与重要性以及核心任务与技术策略',
    text:
      'EOL管理的核心目标以及核心任务技术策略\n' +
      '  定义与范围\n' +
      '     EOL(End of Life)是产品生命周期的最终阶段，聚焦于产品停产后的平稳过渡，\n' +
      '     涵盖停产决策、用户通知、替代方案迁移、零部件回收及知识归档等环节。\n' +
      '     其本质是平衡技术迭代与用户权益，避免退市对品牌声誉造成负面影响\n' +
      '  核心目标\n' +
      '     ＊风险预防：通过EOL测试(功能/性能/兼容性)提前发现潜在问题，\n' +
      '         确保停产后产品仍满足基础使用需求\n' +
      '     ＊资源循环：实现铟(ITO电极)、银(纳米银线)等稀有材料回收率＞90%，\n' +
      '         降低环境负担并控制成本\n' +
      '     ＊用户无缝过渡：为医疗、军工等关键场景客户提供替代方案，\n' +
      '         保障设备持续运行\n' +
      '  EOL测试：质量保障的最后防线\n' +
      '     ＊功能测试：验证触控灵敏(响应延迟＜20ms)、多点触控(≥10点)、\n' +
      '         抗干扰(EMC抗扰度10V/m)等核心功能\n' +
      '     ＊环境可靠性：盐雾测试＞500小时(军工)、-40℃除霜启动(车载)、\n' +
      '         耐消毒剂腐蚀(医疗)\n' +
      '     ＊自动化测试：引入自动化设备(如EOL综合测试系统)，实现绝缘检测、\n' +
      '         BMS通信测试等全流程智能化，效率提升40%\n' +
      '  用户与供应链协同\n' +
      '     ＊用户过渡计划：提前12个月通知客户(如医院手术台设备商、车载主机厂)，\n' +
      '         提供定制化替代方案(如升级为五重复合镀膜)\n' +
      '     ＊保留旧屏技术支持至停产后3年，维护客户忠诚度\n' +
      ' ',
  },
  {
    id: 8,
    // image: require('../images/ServiceImg/Consult/CoreStrength.png'),
    // alt: 'images/ServiceImg/Consult/CoreStrength.png',
    name: '8.	高度集成的核心价值：精简结构，提升系统可靠性',
    title: '高度集成的核心价值',
    subtitle: '高度集成的核心价值：精简结构，提升系统可靠性',
    text:
      '精简结构，提升可靠性\n' +
      '  PCap实现四大突破：\n' +
      '     ＊空间压缩：传统分体式设计厚度≥2.0mm，集成方案(如COG技术)厚度可降至\n' +
      '         0.8mm以下，适配超薄设备(如便携设备、AR眼镜)\n' +
      '     ＊信号保真：功能片与排线直连(如COF/Chip On Film工艺)，减少接插件数量，\n' +
      '         阻抗降低30%，触控响应延迟<10ms(军工级标准)\n' +
      '     ＊环境鲁棒？性：全密封结构(真空贴合+边缘胶密封)支持IP65防护，防尘防水，\n' +
      '         并通过-40℃~+85℃极端温度测试(车载/军工场景)\n' +
      '     ＊功能片(Sensor)—高灵敏度与抗干扰设计\n' +
      '  结构优化\n' +
      '     ＊互容矩阵(X/Y轴交叉感应)消除“鬼点”，支持真实10点触控；微型化布线技术\n' +
      '         将电极宽度缩至5μm，透光率>92%(医疗设备需求)\n' +
      '     ＊排线(走线结构)—低损耗与高可靠性\n' +
      '     ＊多通道独立走线：分层式排线设计(如FPC柔性电路板)，避免信号串扰，\n' +
      '         EMC抗扰度达10V/m(工业EMI环境标准)\n' +
      '     ＊盖板(防护玻璃)—光学与机械性能兼顾\n' +
      '  复合镀膜技术\n' +
      '     ＊AG(防眩)+AR(减反射)+AF(抗菌)多层镀膜，强光下反射率<0.5%\n' +
      '         (户外可视性提升300%)，表面硬度达9H(莫氏硬度)\n' +
      '  结构强化\n' +
      '     ＊化学钢化玻璃抗冲击>10J(GB 15763.2标准)，盐雾测试>500小时(军工认证)\n' +
      '     ＊液晶模块—显示与触控协同优化\n' +
      '     ＊全贴合工艺：真空贴合消除空气层，对比度提升40% ，灰阶响应速度≤5ms，\n' +
      '         解决户外“灰雾”问题\n' +
      '     ＊光学一致性：自然色彩矩阵技术分离亮度信号，色域覆盖sRGB 120%，\n' +
      '         医疗影像显示无偏色\n' +
      ' ',
    describe: 'ServConsultData',
    time: '2025/2/13',
  },
  {
    id: 9,
    // image: require('../images/ServiceImg/Consult/CoreTechStandard.png'),
    // alt: 'images/ServiceImg/Consult/CoreTechStandard.png',
    name: '9.	优化ODM和OEM工作流程',
    title: '优化ODM和OEM工作流程',
    subtitle: '优化ODM和OEM工作流程',
    text: '优化ODM和OEM工作流程\n' +
      '  尺寸与形状\n' +
      '     ＊超大尺寸范围：支持从2吋(医疗手持设备)到85吋(户外广告屏)的尺寸定制，\n' +
      '         满足工业大屏指挥系统、自助终端等需求\n' +
      '     ＊异形切割：可定制圆形、曲面(R3弯曲半径)或非规则形状，适配车载中控、\n' +
      '         可穿戴设备等特殊结构\n' +
      '  厚度与重量优化\n' +
      '     ＊超薄设计：通过COF(Chip on Film)工艺将厚度压缩至0.8mm以下，\n' +
      '         适用于空间受限的航空仪表盘\n' +
      '     ＊轻量化结构：采用薄膜基材替代玻璃，降低设备整体重量(如军工手持终端)\n' +
      '  触控性能提升\n' +
      '     ＊触控点数：支持10点(基础工业)至50点(多手势交互大屏)可调，\n' +
      '         满足复杂操作场景\n' +
      '     ＊响应速度：延迟可优化至<10ms(军工级标准)，确保战场指挥系统的实时性\n' +
      '  环境适应性强化\n' +
      '     ＊极端温度：定制-40~85℃宽温域方案(如寒区车载、高温工业设备)，\n' +
      '         支持-40℃快速除霜(<2分钟)\n' +
      '     ＊防护等级：最高达IP65/IP67，防尘防水，适用于石油钻探、\n' +
      '         医疗手术室等恶劣环境\n' +
      '  光学性能优化\n' +
      '     ＊镀膜组合：定制AG(防眩光)+AR(减反射)+AF(抗菌)多层镀膜\n' +
      '     ＊AG处理雾度5%~30%，适应强光户外环境(如工程机械控制台)\n' +
      '     ＊AF涂层灭菌率>99%，满足医疗设备生物相容性要求\n' +
      '     ＊透光率提升：采用高透OCA光学胶，透光率≥92%(医疗成像设备需>95%)\n' +
      '  特殊防护工艺\n' +
      '     ＊抗UV设计：玻璃下层添加抗UV层，通过1,000小时Q-SUN/QUV老化测试，\n' +
      '         解决户外屏黄变、气泡问题(如挖掘机控制台)\n' +
      '     ＊电磁屏蔽：纳米银线涂层屏蔽效能>40dB，符合军工GJB150抗脉冲标准\n' +
      '  操作模式扩展\n' +
      '     ＊手套/水下模式：通过软件算法调整电容灵敏度，支持厚手套(军工)或\n' +
      '         水下触控(医疗内窥设备)\n' +
      '     ＊触笔兼容性：定制被动式触笔方案，避免医疗、餐饮场景的直接接触，\n' +
      '         降低交叉感染风险\n' +
      '  能源与耐久性优化\n' +
      '     ＊分区加热技术：为寒区车载屏定制局部加热模块，能耗降低30%\n' +
      '     ＊超长寿命设计：军工级结构抗冲击>10J(GB 15763.2标准)，\n' +
      '                                    工业级触控寿命>1亿次，\n' +
      ' ',
    describe: 'ServConsultData',
    time: '2025/2/13',
  },
  {
    id: 10,
    // image: require('../images/ServiceImg/Consult/EolManagement.png'),
    // alt: 'images/ServiceImg/Consult/EolManagement.png',
    name: '10.	从一开始就提供咨询',
    title: '从一开始就提供咨询',
    subtitle: '从一开始就提供咨询',
    text: '从一开始就提供咨询\n' +
      '  简化您的工作流程\n' +
      '     HLZ工程师根据客户需求寻找提高工作效率的机会，实现这一点后，\n' +
      '     设定时间将大幅减少，从而节省成本\n' +
      '  工厂的一体化专业能力\n' +
      '     可以为客户全链条协同降低产品开发风险，更可靠的质量管理，\n' +
      '     加速产品市场化进程\n' +
      ' ',
    describe: 'ServConsultData',
    time: '2025/2/13',
  },
  {
    id: 11,
    // image: require('../images/ServiceImg/Consult/HighIntegratedCoreValue.png'),
    // alt: 'images/ServiceImg/Consult/HighIntegratedCoreValue.png',
    name: '11.	公司基础信息',
    title: '公司基础信息',
    subtitle: '公司基础信息',
    text: '公司基础信息\n' +
      '  公司资料：\n' +
      '     ＊东莞市合利资光电科技有限公司\n' +
      '     ＊成立时间：2013年7月\n' +
      '     ＊地理位置：广东省东莞市大岭山镇大片美路73号2号楼801室\n' +
      '     ＊规模：工厂面积8000平方米，员工约100人\n' +
      '     ＊法定代表人：周梦若\n' +
      '     ＊注册资本：526.3万元人民币\n' +
      '  核心业务与产品\n' +
      '     ＊投射式电容屏(PCap)研发与制造\n' +
      '     ＊技术类型：专注于互电容式投射电容屏，支持多点触控(10点以上)、\n' +
      '         高精度定位(误差≤±1mm)及复杂手势识别\n' +
      '     ＊结构设计：采用G+G(玻璃+玻璃)或GFF(玻璃+薄膜)结构，适配车载、\n' +
      '         工控等严苛环境，具备抗震、宽温(-40℃~85℃)及IP65防护能力\n' +
      '     ＊材料工艺：使用ITO电极或纳米银线(电阻率≤10Ω/□)，结合UV固化LOCA胶\n' +
      '         全贴合技术，透光率≥92%\n' +
      '  触摸(Touch)+显示模组(LCM)总成\n' +
      '     集成触控与显示模块(如LCD/OLED)，提供一体化解决方案，支持曲面屏、\n' +
      '     异形屏定制\n' +
      '  战略合作伙伴\n' +
      '     ＊台湾理义(Liyitec)：华东地区Aiyitec电阻屏代理商???，\n' +
      '         合作拓展工业级触控方案\n' +
      '     ＊芜湖长信科技：国内ITO导电玻璃龙头，供应高端电极材料\n' +
      '     ＊京东方(BOE)：显示面板合作，推动触显一体化模组开发\n' +
      '     ＊奕力(Ilitek)及禾瑞亚(EETI)：触控IC供应商，优化信号处理算法与抗干扰性能\n' +
      ' ',
    describe: 'ServConsultData',
    // link: 'https://touchinternational.com/applications/#top',
    time: '2025/2/13',
  },
]